import React from "react";
import { createPortal } from "react-dom";

export default function GpsMarker({
  svgRoot,
  x,
  y,
  visible = true,
  zoom = 1,
  accuracy = null,
  accuracyRadius = 0,
  headingDeg = null,
  options = {},
}) {
  if (!svgRoot || x == null || y == null) return null;
  if (!visible) return null;

  const {
    id = "gps-marker",
    color = "#1976D2",
    pulseStroke = "rgba(33,150,243,0.8)",
    accFill = "rgba(33,150,243,0.10)",
    accStroke = "rgba(33,150,243,0.45)",
    headR = 7.5,
    pulseR = { from: 14, to: 26 },
    showPulse = true,
    headingCone = {
      length: 80,
      width: 30,
      spreadDeg: null,
      opacity: 0.25,
      fill: color,
    },
  } = options;

  const renderHeadingCone = () => {
    if (headingDeg == null || isNaN(headingDeg)) return null;

    const {
      length = 80,
      width = 30,
      spreadDeg = null,
      opacity = 0.25,
      fill = color,
    } = headingCone;

    console.log("headCone", headingCone);
    const halfAngleRad = (() => {
      if (typeof spreadDeg === "number") return (spreadDeg * Math.PI) / 180 / 2;
      const halfChord = width / 2;
      const ratio = Math.max(
        -1,
        Math.min(1, halfChord / Math.max(1e-6, length))
      );
      return Math.asin(ratio);
    })();
    const halfAngleDeg = (halfAngleRad * 180) / Math.PI;
    const totalAngleDeg = halfAngleDeg * 2;

    const r = length;
    const startDeg = -90 - halfAngleDeg;
    const endDeg = -90 + halfAngleDeg;

    const polar = (radius, deg) => {
      const rad = (deg * Math.PI) / 180;
      return { x: radius * Math.cos(rad), y: radius * Math.sin(rad) };
    };

    const p1 = polar(r, startDeg);
    const p2 = polar(r, endDeg);
    const largeArc = totalAngleDeg > 180 ? 1 : 0;

    const d = [
      `M 0 0`,
      `L ${p1.x} ${p1.y}`,
      `A ${r} ${r} 0 ${largeArc} 1 ${p2.x} ${p2.y}`,
      `Z`,
    ].join(" ");

    const gradientId = `gps-heading-cone-gradient-${id}`;

    return (
      <g id="gps-heading" transform={`rotate(${headingDeg})`}>
        <defs>
          <radialGradient
            id={gradientId}
            gradientUnits="userSpaceOnUse"
            cx="0"
            cy="0"
            r={length}
          >
            <stop offset="0%" stopColor={fill} stopOpacity={opacity} />
            <stop offset="70%" stopColor={fill} stopOpacity={opacity * 0.5} />
            <stop offset="100%" stopColor={fill} stopOpacity="0" />
          </radialGradient>
        </defs>
        <path d={d} fill={`url(#${gradientId})`} pointerEvents="none" />
      </g>
    );
  };

  return createPortal(
    <g
      id={id}
      aria-hidden="true"
      pointerEvents="none"
      transform={`translate(${x}, ${y})`}
    >
      {/* 精度円 */}
      {accuracy != null && accuracyRadius > 0 && (
        <circle
          id="gps-acc"
          r={accuracyRadius}
          fill={accFill}
          stroke={accStroke}
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
        />
      )}

      <g id="gps-sprite" transform={`scale(${1 / zoom})`}>
        {/* パルス */}
        {showPulse && (
          <circle
            id="gps-pulse"
            r={pulseR.from}
            fill="none"
            stroke={pulseStroke}
            strokeWidth="2"
          >
            <animate
              attributeName="r"
              values={`${pulseR.from};${pulseR.to}`}
              dur="1.4s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              values="0.9;0"
              dur="1.4s"
              repeatCount="indefinite"
            />
          </circle>
        )}

        {/* GPSピン */}
        <g id="gps-pin">
          <circle cx="0" cy="0" r={headR + 3} fill="#fff" />
          <circle cx="0" cy="0" r={headR} fill={color} />
        </g>

        {/* ヘディングコーン */}
        {renderHeadingCone()}
      </g>
    </g>,
    svgRoot
  );
}
